import { render } from "./RegionDetail.vue?vue&type=template&id=542f98e9"
import script from "./RegionDetail.vue?vue&type=script&lang=js"
export * from "./RegionDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__